import { useList, useDetail, useCreate, useUpdate, useDelete, fetchApi } from "@inmagik/react-crud"
import { Formato } from "../types"
import { API_URL } from "../constants"
import { useCallback } from "react"
import { normalizeParams } from "@inmagik/react-crud/dist/crud/utils"
import { useAuth } from "../auth"

export function useFormatiList(
  params: // accept also list of ids
  Record<string, string | number | Array<number>> = {},
  enabled = true
) {
  return useList<Formato>(`${API_URL}/admin/formati`, {
    query: params,
    reactQuery: {
      enabled: enabled,
      queryKey: ["formati", params],
    },
  })
}

export function useFormato(id: number | undefined) {
  return useDetail<Formato>(`${API_URL}/admin/formati`, id?.toString())
}

export function useFormatoLazy() {
  const auth = useAuth()
  return useCallback((id: number) => {
    return fetchApi(`${API_URL}/admin/formati/${id}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<Formato>
  }, [])
}

export function useFormatiLazy() {
  const auth = useAuth()
  return useCallback((params: Record<string, string | number | Array<number>>) => {
    const qs = normalizeParams(params).toString()
    return fetchApi(`${API_URL}/admin/formati?${qs}`, {
      method: "GET",
      responseType: "json",
      headers: {
        Authorization: `Bearer ${auth.tokens?.access}`,
      },
    }) as Promise<{ results: Formato[] }>
  }, [])
}

export function useFormatoCreate() {
  return useCreate<Formato>(`${API_URL}/admin/formati`)
}

export function useFormatoUpdate() {
  return useUpdate<Formato>(`${API_URL}/admin/formati`)
}

export function useFormatoDelete() {
  return useDelete(`${API_URL}/admin/formati`)
}
